// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  scholUrl: "https://schol2qa.e-gmattest.com",
  // Customer.io In-App messaging (CDP / client-side SDK).
  // Gated: if customerIoCdpKey is empty the integration is a complete no-op.
  // NOTE: this is the public CDP (JS source) write key + Tracking Site ID only.
  // The Customer.io Track/App API key is a server-side secret and must NEVER appear here.
  customerIoCdpKey: "0211e14534672f80dce5",
  customerIoSiteId: "480a5e1a85d84ddce7d2",
  customerIoRegion: "us",
};
